module.exports = __webpack_public_path__ + "assets/img/driver-btn-e3b4c4b0.png";